import {
  Button,
  Col,
  Dropdown,
  Input,
  Menu,
  message,
  Modal,
  Row,
  Table,
} from "antd";
import axios from "axios";
import React, { useEffect, useState, Fragment } from "react";
import { Link, Redirect } from "react-router-dom";
import { url } from "../../constant/url";
import { EditOutlined, DeleteOutlined, PlusOutlined } from "@ant-design/icons";

function TesNG(history) {
  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      sorter: true,
    },
    {
      title: "Department",
      dataIndex: "plan_name",
      key: "plan_name",
    },
    {
      title: "Main Process Name",
      dataIndex: "main_processes",
      key: "main_processes",
      sorter: false,
    },
    {
      title: "Line Process Name",
      dataIndex: "line_processes",
      key: "line_processes",
      sorter: false,
    },
    {
      title: "",
      dataIndex: "_id",
      key: "id",
      sorter: false,
      fixed: "right",
      width: 50,
      render: (id, data) => {
        return (
          <>
            <Dropdown
              className="pointer"
              overlay={
                <Menu>
                  <Menu.Item key="1">
                    <Link to={`/tes-ng/edit/${id}`}>
                      <EditOutlined /> Edit
                    </Link>
                  </Menu.Item>
                  {data.children == false && (
                    <Menu.Item key="3">
                      <span onClick={() => handleDelete(id)}>
                        <DeleteOutlined />
                        Delete
                      </span>
                    </Menu.Item>
                  )}
                </Menu>
              }
              trigger={["click"]}
            >
              <span className="pointer" onClick={(e) => e.preventDefault()}>
                <i className="mdi mdi-dots-vertical" />
              </span>
            </Dropdown>
          </>
        );
      },
    },
  ];

  const [page, setPage] = useState(1);
  const [perpage, setPerpage] = useState(10);
  const [sort, setSort] = useState({
    sort: "created_at",
    order: "ascend",
  });
  const [loading, setLoading] = useState(false);
  const [keyword, setKeyword] = useState("");
  const [ngs, setNgs] = useState([]);

  useEffect(() => {
    getData();
  }, [keyword, page, perpage, sort]);

  const getData = () => {
    setLoading(true);
    axios
      .get(`${url}/ng`, {
        params: {
          keyword,
          columns: [
            "name",
            "plan_id",
            "plan_name",
            "main_processes",
            "line_processes",
          ],
          perpage: perpage,
          page,
          sort: sort.sort,
          order: sort.order,
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
      .then((res) => {
        setNgs(res.data.data);
        // setNgs(
        //   res.data.data.map((ng) => {
        //     return {
        //       ...ng,
        //       children:
        //         ng.children.length > 0
        //           ? ng.children.map((children) => {
        //               return {
        //                 ...children,
        //                 children: null,
        //               };
        //             })
        //           : null,
        //     };
        //   })
        // );
      })
      .catch((err) => {
        if (err.response) {
          message.error(err.response.data.message);
          if (err.response.status === 401) {
            localStorage.removeItem("token");
          }
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleDelete = (id) => {
    Modal.confirm({
      title: "Are you sure ?",
      content: (
        <div>
          <p>Deleted data cannot be restored</p>
        </div>
      ),
      okText: "Delete",
      showCancel: true,
      onCancel: () => {
        return;
      },
      cancelText: "Cancel",
      confirmLoading: loading,
      onOk: async () => {
        confirmDelete(id);
      },
    });
  };

  const confirmDelete = (id) => {
    setLoading(true);
    axios
      .delete(`${url}/ng/${id}`, {
        params: {
          keyword,
          columns: ["name"],
          perpage: perpage,
          page,
          sort: sort.sort,
          order: sort.order,
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
      .then((res) => {
        message.success(res.data.message);
        getData();
      })
      .catch((err) => {
        if (err.response) {
          message.error(err.response.data.message);
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleTableChange = (pagination, filters, sorter) => {
    setPage(pagination.current);
    setPerpage(pagination.pageSize);
    setSort({
      sort: sorter.field,
      order: sorter.order,
    });
  };

  return localStorage.getItem("token") ? (
    <div>
      <ul className="breadcumb">
        <li className="active">NG</li>
      </ul>
      <div className="content">
        <Row justify="space-between">
          <Col>
            <Link to="/tes-ng/create">
              <Button
                type="primary"
                style={{ backgroundColor: "#1b2086", borderColor: "#1b2086" }}
              >
                <PlusOutlined />
                Add
              </Button>
            </Link>
          </Col>
          <Col>
            <Input.Search
              allowClear="true"
              onSearch={(value) => setKeyword(value)}
              placeholder="Search..."
            />
          </Col>
        </Row>
        <Row className="mt-40">
          <Col xs={24}>
            <Table
              columns={columns}
              dataSource={ngs}
              pagination={{ total: ngs.length, showSizeChanger: true }}
              loading={loading}
              rowKey={(data) => data._id}
              onChange={handleTableChange}
            />
          </Col>
        </Row>
      </div>
    </div>
  ) : (
    <Redirect to="/login" />
  );
}

export default TesNG;
